import { useCurrentPractice } from 'contexts/PracticeContext'
import { Navigate } from 'react-router-dom'

const ActivePracticeGuard = ({ children }) => {
	const { isCurrentPracticeActive } = useCurrentPractice()

	if (!isCurrentPracticeActive) {
		return <Navigate to="/dashboard" replace />
	}

	return children
}

export default ActivePracticeGuard
